import { registerOverlayResetHandler } from '../../shared/ports/sessionResetPort';
import { resetAllInventorySlices } from '../store/index';

registerOverlayResetHandler(() => {
  resetAllInventorySlices();
});
